import { withViewModel } from '@hooks/useViewModel';
import RHFCompanySelect from './RHFCompanySelect';
import useRHFCompanySelect from './useRHFCompanySelect';

const CompanySelectContainer = withViewModel(RHFCompanySelect, useRHFCompanySelect);

export default CompanySelectContainer;
